import styled from "styled-components";
import React, {useEffect, useState} from "react";
import {GreyButton} from "../buttons/ButtonStyles";

const SearchBarByCriticality = ({setData, data}) => {

    const criticalityValues = [{
        id: "moderate-criticality",
        value: 1,
        name: "Normale",
        color: 'yellow'
    }, {id: 'high-criticality', value: 2, name: "Élevée", color: "red"}]
    const [selectedCriticality, setSelectedCriticality] = useState({})

    useEffect(() => {
        return () => {
            setData(data)
        }
    }, [data, setData])

    useEffect(() => {
        setData(data.filter(a => a.criticality === selectedCriticality.value))
    }, [data, selectedCriticality.value, setData])

    return (


        <SearchBar>
            {criticalityValues.map((c,) => (
                <Button
                    key={c.id}
                    $mode={selectedCriticality.id === c.id}
                    onClick={() => setSelectedCriticality(c)}
                >
                    <div className={`dots ${c.color}-dots`}/>
                    {c.name}
                </Button>
            ))}

        </SearchBar>

    )
}

const SearchBar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  width: 30%;
`

const Button = styled(GreyButton)`

`

export default SearchBarByCriticality